import * as mutationType from "../mutation_types";
import moment from "moment";
import _ from "lodash";

const state = {
  surveys: [],
  outstanding: {},
  edit_survey: {},
  survey_templates: [],
  survey_questions: [],
  survey_schedule: {},
  instance: {}
};

const getters = {
  surveys: state => state.surveys,
  outstanding: state => state.outstanding,
  edit_survey: state => state.edit_survey,
  survey_schedule: state => state.survey_schedule,
  survey_templates: state => state.survey_templates,
  survey_questions: state => state.survey_questions,
  instance: state => state.instance
};

const actions = {
  getSurveys({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/surveys")
        .then(res => {
          commit(mutationType.SET_SURVEYS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getOutstandingSurveys({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/surveys/outstanding")
        .then(res => {
          commit(mutationType.SET_OUTSTANDING_SURVEYS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getSurvey({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/surveys/" + id)
        .then(res => {
          commit(mutationType.SET_EDIT_SURVEY, res.data);
          commit(
            mutationType.SET_SURVEY_SCHEDULE,
            _.cloneDeep(res.data.schedule)
          );
          resolve(res.data);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  resetSurvey({ commit }) {
    return new Promise(resolve => {
      commit(mutationType.SET_EDIT_SURVEY, {});
      commit(mutationType.SET_SURVEY_QUESTIONS, []);
      resolve();
    });
  },
  saveSurveyWithQuestions({ commit }, survey) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/surveys", survey)
        .then(res => {
          commit(mutationType.SET_EDIT_SURVEY, res.data.survey);
          commit(mutationType.SET_SURVEY_QUESTIONS, res.data.questions);
          resolve(res.data.survey.id);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  completeSurvey({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`/api/surveys/${id}/complete`)
        .then(() => {
          commit(mutationType.COMPLETE_SURVEY, id);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  deleteSurvey({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete("/api/surveys/" + id)
        .then(() => {
          commit(mutationType.DELETE_SURVEY, id);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getSurveyInstances({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/surveys/" + id + "/instances")
        .then(res => {
          commit(mutationType.SET_SURVEY_INSTANCES, {
            surveyId: id,
            list: res.data
          });
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveSurveySchedule({ commit, state }, schedule) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/surveys/" + state.edit_survey.id + "/schedule", schedule)
        .then(res => {
          commit(mutationType.SET_SURVEY_SCHEDULE, schedule);
          commit(mutationType.SET_SURVEY_SCHEDULE_ID, res.data);
          commit(mutationType.SET_SURVEY_SCHEDULE_PAUSED, false);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  resetSurveySchedule({ commit, state }) {
    return new Promise(resolve => {
      commit(
        mutationType.SET_SURVEY_SCHEDULE,
        _.cloneDeep(state.edit_survey.schedule)
      );
      resolve();
    });
  },
  // eslint-disable-next-line no-empty-pattern
  duplicateSurvey({}, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/surveys/" + id + "/duplicate")
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getSurveyTemplates({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/surveyTemplates")
        .then(res => {
          commit(mutationType.SET_SURVEY_TEMPLATES, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getSurveyQuestions({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/surveys/" + state.edit_survey.id + "/questions")
        .then(res => {
          commit(mutationType.SET_SURVEY_QUESTIONS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveSurveyQuestions({ commit, state }, list) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/surveys/" + state.edit_survey.id + "/questions", list)
        .then(() => {
          commit(mutationType.SET_SURVEY_QUESTIONS, []);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getSurveyTemplate({ commit }, templateId) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/surveyTemplates/" + templateId)
        .then(res => {
          let questions = res.data.questions;
          _.each(questions, function(question) {
            question.id = "";
            _.each(question.multipleChoiceAnswers, function(answer) {
              answer.id = "";
            });
          });
          let survey = res.data.survey;
          survey.id = null;
          commit(mutationType.SET_EDIT_SURVEY, survey);
          commit(mutationType.SET_SURVEY_QUESTIONS, questions);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  pauseSurveySchedule({ commit, state }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put("/api/surveys/" + state.edit_survey.id + "/schedule/pause")
        .then(() => {
          commit(mutationType.SET_SURVEY_SCHEDULE_PAUSED, true);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getSurveyInstance({ commit }, instance) {
    return new Promise((resolve, reject) => {
      if (!instance.id) {
        commit(mutationType.SET_SURVEY_INSTANCE, {
          surveyId: instance.surveyId,
          liveLink: false
        });
        resolve();
        return;
      }
      this._vm.$http
        .get("/api/surveys/" + instance.surveyId + "/instances/" + instance.id)
        .then(res => {
          commit(mutationType.SET_SURVEY_INSTANCE, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveSurveyInstance({ commit }, instance) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/surveys/" + instance.surveyId + "/instances", instance)
        .then(res => {
          if (res.data) {
            commit(mutationType.SET_SURVEY_INSTANCE, res.data);
          }
          resolve(res.data);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  addRecipientsToSurveyInstance({ commit }, instance) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post(
          `/api/surveys/${instance.surveyId}/instances/${instance.id}/recipients`,
          instance.recipients
        )
        .then(res => {
          if (res.data) {
            commit(mutationType.SET_SURVEY_INSTANCE, res.data);
          }
          resolve(res.data);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  deleteSurveyInstance({ commit }, instance) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete(`/api/surveys/${instance.surveyId}/instances/${instance.id}`)
        .then(() => {
          commit(mutationType.DELETE_SURVEY_INSTANCE, instance);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  closeSurveyInstance({ commit }, instance) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`/api/surveys/${instance.surveyId}/instances/${instance.id}/close`)
        .then(() => {
          commit(mutationType.CLOSE_SURVEY_INSTANCE, instance);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  generateLiveSurvey({}, instance) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`/api/surveys/${instance.surveyId}/instances/${instance.id}/live`)
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  }
};

const mutations = {
  [mutationType.SET_SURVEYS](state, list) {
    state.surveys = list;
  },
  [mutationType.SET_OUTSTANDING_SURVEYS](state, item) {
    state.outstanding = item;
  },
  [mutationType.SET_EDIT_SURVEY](state, survey) {
    state.edit_survey = survey;
  },
  [mutationType.COMPLETE_SURVEY](state, id) {
    let index = state.surveys.findIndex(cv => cv.id == id);
    if (index >= 0) {
      this._vm.$set(state.surveys[index], "isComplete", true);
      this._vm.$set(state.surveys[index], "instances", []);
    }
  },
  [mutationType.DELETE_SURVEY](state, id) {
    let index = state.surveys.findIndex(cv => cv.id == id);
    if (index >= 0) {
      state.surveys.splice(index, 1);
    }
  },
  [mutationType.SET_SURVEY_INSTANCES](state, item) {
    let index = state.surveys.findIndex(x => x.id == item.surveyId);
    if (index >= 0) {
      this._vm.$set(state.surveys[index], "instances", item.list);
      this._vm.$set(
        state.surveys[index],
        "scheduledInstancesCount",
        item.list.filter(x => x.sentDate == null).length
      );
    }
  },
  [mutationType.SET_SURVEY_SCHEDULE](state, schedule) {
    if (schedule == null) {
      schedule = {
        recurringRule: "",
        startDate: moment().format("YYYY-MM-DD")
      };
    }
    state.survey_schedule = schedule;
    state.edit_survey.schedule = schedule;
  },
  [mutationType.SET_SURVEY_SCHEDULE_ID](state, id) {
    this._vm.$set(state.survey_schedule, "id", id);
  },
  [mutationType.SET_SURVEY_TEMPLATES](state, list) {
    state.survey_templates = list;
  },
  [mutationType.SET_SURVEY_QUESTIONS](state, list) {
    state.survey_questions = list;
  },
  [mutationType.SET_SURVEY_SCHEDULE_PAUSED](state, paused) {
    if (paused != true) {
      paused = false;
    }
    this._vm.$set(state.survey_schedule, "isPaused", paused);
    this._vm.$set(state.edit_survey.schedule, "isPaused", paused);
  },
  [mutationType.SET_SURVEY_INSTANCE](state, item) {
    state.instance = item;
  },
  [mutationType.DELETE_SURVEY_INSTANCE](state, item) {
    let sIndex = state.surveys.findIndex(cv => cv.id == item.surveyId);
    if (sIndex >= 0) {
      let iIndex = state.surveys[sIndex].instances.findIndex(
        cv => cv.id == item.id
      );
      if (iIndex >= 0) {
        state.surveys[sIndex].instances.splice(iIndex, 1);
      }
      this._vm.$set(
        state.surveys[sIndex],
        "scheduledInstancesCount",
        state.surveys[sIndex].instances.filter(x => x.sentDate == null).length
      );
    }
  },
  [mutationType.CLOSE_SURVEY_INSTANCE](state, item) {
    let sIndex = state.surveys.findIndex(cv => cv.id == item.surveyId);
    if (sIndex >= 0) {
      let iIndex = state.surveys[sIndex].instances.findIndex(
        cv => cv.id == item.id
      );
      if (iIndex >= 0) {
        this._vm.$set(
          state.surveys[sIndex].instances[iIndex],
          "isComplete",
          true
        );
        this._vm.$set(
          state.surveys[sIndex].instances[iIndex],
          "finishDate",
          moment()
        );
      }
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
